webpackJsonp([39739060484641],{

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(765);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SupportPage = function (_Component) {
	    _inherits(SupportPage, _Component);
	
	    function SupportPage() {
	        _classCallCheck(this, SupportPage);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    SupportPage.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'support-container' },
	            _react2.default.createElement(_reactHelmet2.default, { title: 'Datasert - Support' }),
	            _react2.default.createElement(
	                'div',
	                { className: 'content' },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Using Realfire?'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Please use the "Help -> Contact Support" menu to send us a support request. Please include the errors logs so we can understand the issue and resolve it faster.'
	                ),
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Email Us'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Please email us at ',
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'mailto:support@datasert.com' },
	                        'support@datasert.com'
	                    ),
	                    ' and we will do our best to have it resolved.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'If we determine the issue is not isolated to you alone, we will create an issue in Github and track it.'
	                ),
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Have a feature requetst?'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Please create an issue in appropriate product repo at ',
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'https://github.com/datasert' },
	                        'https://github.com/datasert'
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'If the feature request is appropriate, we will do our best to have it implemented as soon as we can'
	                )
	            )
	        );
	    };
	
	    return SupportPage;
	}(_react.Component);
	
	exports.default = SupportPage;
	module.exports = exports['default'];

/***/ }),

/***/ 765:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-resources-support-jsx-ac46c68a7c4866355f38.js